export { FunnelBadge } from './FunnelBadge';
